module.exports = __webpack_public_path__ + "static/guide_nybyg.min-6406974229529bb8c0bf774aeeee0dbd.png";